import './AnimatedGradientLayer.css';

const AnimatedGradientLayer = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 h-[30vh] pointer-events-none z-0 overflow-hidden">
      {/* Capa de blur para el efecto de difuminado */}
      <div className="absolute inset-0 backdrop-blur-3xl"></div>
      
      {/* Degradado animado */}
      <div className="gradient-container">
        <div className="gradient-ellipse"></div>
      </div>
      
      {/* Overlay de blur adicional para suavizar */}
      <div className="absolute inset-0 bg-gradient-to-t from-transparent via-transparent to-[#07182D] opacity-40"></div>
    </div>
  );
};

export default AnimatedGradientLayer;